<template>
<div class="ibox ">
    <div class="ibox-title">
        <h5>Interacciones del dia</h5>
        <div class="ibox-tools">
            <a class="collapse-link">
                <i class="fa fa-chevron-up"></i>
            </a>
        </div>
    </div>
    <div class="ibox-content">
        <div class="row">
            <!--                <div class="col-sm-9 m-b-xs">-->
            <!--                    <div data-toggle="buttons" class="btn-group btn-group-toggle">-->
            <!--                        <label class="btn btn-sm btn-white"> <input type="radio" id="option1" name="options"> Day </label>-->
            <!--                        <label class="btn btn-sm btn-white active"> <input type="radio" id="option2" name="options"> Week </label>-->
            <!--                        <label class="btn btn-sm btn-white"> <input type="radio" id="option3" name="options"> Month </label>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--                <div class="col-sm-3">-->
            <!--                    <div class="input-group mb-3">-->
            <!--                        <input type="text" class="form-control form-control-sm" placeholder="Search">-->
            <!--                        <div class="input-group-append">-->
            <!--                            <button class="btn btn-sm btn-primary" type="button">Go!</button>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->
        </div>
        <datatable :data="inters"></datatable>
      

    </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex'

import datatable from './Datatable'
export default {
    components: { datatable },
    data: function () {
        return {
            inter_global: null,
          
        }
    },
    props: {
        interaccion: {
            default: () => ({})
        },
    },
    mounted() {
        this.obtenerInteracciones()
    },
    methods: {
        obtenerInteracciones() {
            this.$store.dispatch('interacciones/obtenerInteracciones')
                .then(response => {
                    // console.log(response.data);
                }).catch(error => {
                    //
                })
        },
      
    },
    computed: {
        inters:{
            get(){
                let x = this.$store.getters['interacciones/getInteracciones'];
                // console.log(x);
                return x
            }
        }
    }
}
</script>
